module.exports = require('./build/extpoints.cjs.js')
